import { CartProvider } from "@/contexts/CartContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ProductGrid from "@/components/ProductGrid";
import InsuranceSection from "@/components/InsuranceSection";
import PaymentSection from "@/components/PaymentSection";
import PhoneSuggestions from "@/components/PhoneSuggestions";
import AccessorySuggestions from "@/components/AccessorySuggestions";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CartDrawer from "@/components/CartDrawer";
import InstallPWA from "@/components/InstallPWA";
import AIChatbot from "@/components/AIChatbot";
import PhoneRecommendation from "@/components/PhoneRecommendation";
import AccessoryGrid from "@/components/AccessoryGrid";

const Index = () => {
  return (
    <CartProvider>
      <div className="min-h-screen bg-background">
        <Navbar />
        <Hero />
        <ProductGrid />
        <section className="relative pb-32 pt-8">
          <div className="container mx-auto px-4">
            <PhoneRecommendation />
          </div>
          <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-b from-transparent via-background/50 to-secondary pointer-events-none" />
        </section>
        <AccessoryGrid />
        <InsuranceSection />
        <PaymentSection />
        <PhoneSuggestions />
        <AccessorySuggestions />
        <Footer />
        <WhatsAppButton />
        <CartDrawer />
        <InstallPWA />
        <AIChatbot />
      </div>
    </CartProvider>
  );
};

export default Index;
